import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false

// 使用ElementUI
Vue.use(ElementUI)

// 配置axios - 生产环境使用完整域名
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://api.jyhcyl.com/api'
axios.defaults.timeout = 10000

// 图片基础URL
const IMAGE_BASE_URL = process.env.VUE_APP_IMAGE_URL || 'https://api.jyhcyl.com'

// 全局方法：获取完整图片URL
Vue.prototype.$getImageUrl = (path) => {
  if (!path) return ''
  if (path.startsWith('http')) return path
  return IMAGE_BASE_URL + path
}

// 请求拦截器
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      ElementUI.Message.error(res.message || '请求失败')
      if (res.code === 401) {
        localStorage.removeItem('token')
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    ElementUI.Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios
Vue.prototype.$message = ElementUI.Message

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
